// Quest Browser treats a navigation or context loss inside an active immersive
// session as a crash and restores the current page: end the session first.
export function endXRSession(session, timeout = 1500) {
  if (!session) return Promise.resolve('none')
  return new Promise(resolve => {
    let settled = false
    const finish = result => {
      if (settled) return
      settled = true
      clearTimeout(timer)
      resolve(result)
    }
    const timer = setTimeout(() => finish('timeout'), timeout)
    session.addEventListener('end', () => finish('ended'), { once: true })
    try {
      Promise.resolve(session.end()).catch(() => finish('ended'))
    } catch (error) {
      // InvalidStateError: the session has already ended.
      finish('ended')
    }
  })
}
